import * as React from 'react';
import glamorous from 'glamorous';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { RvLoader } from '../../components/Loader';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { IconButtonWrapper, ChartCommonProps, ChartCommonState, FooterDescription, HelpWrapper } from '../Common';
import { GetArrow, formatNumber, getMaxSuggestedTick, getHighestNumberInArray } from '../../helpers/ChartHelper';
import { WithStyles, withStyles, IconButton } from '@material-ui/core';
import { styles } from '../styles';
import { ChartFilter } from '../ChartComponents';
import { SelectedItemProps } from '../MattersByStatusChart';
import { DrillDownType } from '../DrillDownType';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { ChartInfo } from '../../components/ChartInfo';
import MTooltip from '@material-ui/core/Tooltip';
import VideoLibraryOutlinedIcon from '@material-ui/icons/VideoLibraryOutlined';
import { VideoModal } from '../../components/VideoModal';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvLegendLabels, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartEmptyState } from '../ChartEmptyState';
import PeopleOutlinedIcon from '@material-ui/icons/PeopleOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const BarWrapper = glamorous.div<{ theme?: object }>((props) => ({
    position: 'relative',
    paddingBottom: '10px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100%',
    '@media print': {
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'center',
    },
}));

const BarTitleContainer = glamorous.div<{ theme?: object }>((props) => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '15px 15px 0px 15px',
    fontSize: '16px',
    fontWeight: 600,
    [`& .${`h1`}`]: {
        display: 'flex',
        alignItems: 'center',
    },
    [`& .${`h2`}`]: {
        fontSize: '2.5rem',
        padding: '10px 0',
    },
    [`& .${`h3`}`]: {
        paddingTop: '10px',
    },
})).withProps({ className: 'rv-chart-title-area' });

const BarContainer = glamorous.div<{ theme?: object }>((props) => ({
    padding: '5px 15px 15px 15px',
    minHeight: '300px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: '350px',
    maxWidth: 'auto',
    position: 'relative',
    '@media (max-width: 533px)': {
        maxWidth: '350px',
        margin: '0 auto',
    },
    [`& .${`titleWrapper`}`]: {
        textAlign: 'center',
        display: 'inline-block',
        width: '100%',
        padding: '15px',
        [`& .${`title`}`]: {
            fontSize: '18px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`value`}`]: {
            fontSize: '24px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`secondary-title`}`]: {
            fontSize: '16px',
            fontWeight: 400,
            display: 'block',
            marginBottom: '15px',
        },
    },
}));

const LoadWrapper = glamorous.div<{ theme?: object }>((props) => ({
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
}));

const TotalDiv = glamorous.div<{ theme?: object }>((props) => ({
    cursor: 'pointer',
    paddingRight: 5,
}));

interface ChartProps extends SelectedItemProps, ChartCommonProps, WithStyles<typeof styles> {
    chartFilter?: ChartFilter;
    infoUrl: string | null;
}

interface ChartState extends ChartCommonState {
    isVideoModalOpen: boolean;
}

class NewLeadsVsThreeYearsAverageChart extends React.Component<ChartProps, ChartState> {
    // tslint:disable-next-line: no-any
    public chartRef: React.RefObject<any>;

    constructor(props: ChartProps, state: ChartState) {
        super(props, state);
        this.onCloseChart = this.onCloseChart.bind(this);
        this.handlePopoverOpen = this.handlePopoverOpen.bind(this);
        this.handlePopoverClose = this.handlePopoverClose.bind(this);
        this.handleTotalClick = this.handleTotalClick.bind(this);
        this.onPan = this.onPan.bind(this);
        this.chartRef = React.createRef();
        this.onHover = this.onHover.bind(this);
        this.onToggleVideo = this.onToggleVideo.bind(this);

        this.state = {
            open: false,
            anchorEl: undefined,
            isVideoModalOpen: false
        };
    }

    public componentDidMount() {
        //
    }

    public componentWillUnmount() {
        //
    }

    public shouldComponentUpdate(nextProps: ChartProps, nextState: ChartState): boolean {
        if (this.props !== nextProps || this.state !== nextState) {
            return true;
        }

        return false;
    }

    public render() {
        // const { classes } = this.props;
        var symbol = '';
        return (
            <React.Fragment>
                {this.state.isVideoModalOpen && this.props.infoUrl && (
                    <VideoModal 
                        open={this.state.isVideoModalOpen}
                        onClose={this.onToggleVideo}
                        url={this.props.infoUrl}
                    />
                )}
                {/* tslint:disable-next-line: no-any */}
                <Query<any> query={CurrencySymbol}>
                    {(result) => {
                        if (result.loading) {
                            return (
                                <ChartSkeleton variant="columns" />
                            );
                        }

                        const currencySymbol = result.loading || result.error ? null : result.data.options.currencySymbol;

                        symbol = currencySymbol ? currencySymbol.symbol : null;

                        return (
                            // tslint:disable-next-line: no-any
                            <Query<NewMatterLeadVsAverageByMonthDataData, NewMatterLeadVsAverageByMonthDataVariables>
                                query={NewMatterLeadVsAverageByMonthDataQuery}
                                variables={{
                                    entityType: this.props.chartFilter?.entityType,
                                    entityGuid: this.props.chartFilter?.entityGuid,
                                    responsibility: this.props.chartFilter?.responsibility,
                                    filter: this.props.chartFilter?.filter
                                }}
                            >
                                {({ loading, error, data }) => {
                                    if (loading) {
                                        return (
                                            <LoadWrapper className="load-wrapper">
                                                <RvLoader size="small" />
                                            </LoadWrapper>
                                        );
                                    }

                                    const statistics = data?.statistics;

                                    let matter = loading || error || statistics === null || statistics === undefined ? null : statistics.matter;

                                    let newMatterLeadVsAverageByMonth = matter ? matter.newMatterLeadVsAverageByMonth : null;

                                    if (newMatterLeadVsAverageByMonth && newMatterLeadVsAverageByMonth.newMatterLeadCount && newMatterLeadVsAverageByMonth.lastThreeYearsNewMatterLeadCount) {
                                        const lastTwelveMonths = newMatterLeadVsAverageByMonth.matterLeadsOpenedCountTotal;
                                        const previousTwelveMonths = newMatterLeadVsAverageByMonth.previousYearMatterLeadsOpenedCountTotal;
                                        // tslint:disable-next-line: no-any
                                        let months = newMatterLeadVsAverageByMonth.newMatterLeadCount.map((value) => {
                                            return value.month;
                                        });
                                        // tslint:disable-next-line: no-any
                                        let years = newMatterLeadVsAverageByMonth.newMatterLeadCount.map((value) => {
                                            return value.year;
                                        });

                                        // tslint:disable-next-line: no-any
                                        let newMatterCount = newMatterLeadVsAverageByMonth.newMatterLeadCount.map((value) => {
                                            return value.count;
                                        });
                                        // tslint:disable-next-line: no-any
                                        let estimates = newMatterLeadVsAverageByMonth.newMatterLeadCount.map((value) => {
                                            return value.estimate;
                                        });

                                        // tslint:disable-next-line
                                        let lastThreeYearsNewMatterCount = newMatterLeadVsAverageByMonth.lastThreeYearsNewMatterLeadCount.map((value) => {
                                            return value.count;
                                        });

                                        return (
                                            <BarWrapper className={RV_CHART_CLASS}>
                                                <IconButtonWrapper aria-label="close">
                                                     <HelpWrapper className="rv-chart-help">
                                                        <ChartInfo 
                                                            description={this.props.description}
                                                        />
                                                        {this.props.infoUrl && (
                                                            <MTooltip title="Learn more">
                                                                <IconButton
                                                                    style={{ color: 'rgb(0, 120, 212)' }}
                                                                    aria-label="maximize"
                                                                    onClick={this.onToggleVideo}
                                                                    size={this.props.showAllRecords ? 'medium' : 'small'}
                                                                >
                                                                    <VideoLibraryOutlinedIcon />
                                                                </IconButton>
                                                            </MTooltip>
                                                        )}
                                                    </HelpWrapper>
                                                    <IconButton aria-label="close" onClick={this.onCloseChart} size="small">
                                                        <CloseIcon />
                                                    </IconButton>
                                                </IconButtonWrapper>
                                                <BarTitleContainer>
                                                    <ChartHeading icon={<PeopleOutlinedIcon />} title="New Leads This Year" />
                                                    <TotalDiv className="h2" onClick={() => this.handleTotalClick(true)}>
                                                        <AnimatedNumber value={lastTwelveMonths.count} format={(amount) => formatNumber(amount)} />
                                                        {GetArrow(lastTwelveMonths.count, previousTwelveMonths.count)}
                                                    </TotalDiv>
                                                    <div className="h3">
                                                        <TotalDiv onClick={() => this.handleTotalClick(false)}>{formatNumber(previousTwelveMonths.count)}</TotalDiv>
                                                        leads opened in the 12 months before that
                                                    </div>
                                                </BarTitleContainer>
                                                <BarContainer className="rv-chart-bars">
                                                    <Bar
                                                        ref={this.chartRef}
                                                        // tslint:disable-next-line: no-any
                                                        onClick={(event: React.MouseEvent<any>) => {
                                                            const _data = getElementAtEvent(this.chartRef.current, event);
                                                            if (_data.length > 0 && this.props.getSelectedItem) {
                                                                const _index = getElementAtEvent(this.chartRef.current, event)[0].index;

                                                                const month = months[_index];
                                                                const year = years[_index];

                                                                const searchCriterias = new Array<SearchCriteria>();

                                                                searchCriterias.push(
                                                                    { property: 'InstructionDateMonth', operator: 'eq', comparison: month },
                                                                    { property: 'InstructionDateYear', operator: 'eq', comparison: year || '' },
                                                                    { property: 'isLead', operator: 'eq', comparison: 'true' },
                                                                );

                                                                this.props.getSelectedItem(
                                                                    searchCriterias,
                                                                    false,
                                                                    'New Matters vs Average',
                                                                    DrillDownType.matterSummaryDrilldown,
                                                                    'Matters',
                                                                    undefined,
                                                                    undefined,
                                                                    undefined,
                                                                    undefined,
                                                                    true
                                                                );
                                                            }
                                                        }}
                                                        data={{
                                                            labels: months,
                                                            datasets: [
                                                                {
                                                                    label: '2 years average',
                                                                    // fill: false,
                                                                    backgroundColor: RV_CHART_COLORS.amber,
                                                                    borderColor: RV_CHART_COLORS.amber,
                                                                    borderWidth: 3,
                                                                    hoverBackgroundColor: RV_CHART_COLORS.amber,
                                                                    hoverBorderColor: RV_CHART_COLORS.amber,
                                                                    tension: 0.35,
                                                                    pointRadius: 0,
                                                                    data: lastThreeYearsNewMatterCount,
                                                                    type: 'line',
                                                                    pointStyle: 'line',
                                                                },
                                                                {
                                                                    label: 'Leads',
                                                                    ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                                                    type: 'bar',
                                                                    data: newMatterCount,
                                                                },
                                                            // tslint:disable-next-line: no-any
                                                            ] as any,
                                                        }}
                                                        options={{
                                                            onHover: this.onHover,
                                                            indexAxis: 'x' as const,
                                                            animation: rvChartAnimation(),
                                                            elements: { bar: { borderWidth: 0 } },
                                                            responsive: true,
                                                            maintainAspectRatio: false,
                                                            scales: {
                                                                y: {
                                                                    grid: rvValueAxisStyle.grid,
                                                                    // beginAtZero: true,
                                                                    suggestedMax: getMaxSuggestedTick(
                                                                        getHighestNumberInArray([...lastThreeYearsNewMatterCount, ...newMatterCount]),
                                                                        6,
                                                                    ),
                                                                    min: 0,
                                                                    ticks: {
                                                                        ...rvValueAxisStyle.ticks,
                                                                        autoSkip: false,
                                                                        callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                                                            return `${formatNumber(tickValue)}`;
                                                                        },
                                                                    },
                                                                },
                                                                x: {
                                                                    grid: rvCategoryAxisStyle.grid,
                                                                    // min: 0,
                                                                    // max: 11 // minimum display
                                                                    ticks: {
                                                                        ...rvCategoryAxisStyle.ticks,
                                                                        autoSkip: false
                                                                    }
                                                                }
                                                            },
                                                            plugins: {
                                                                legend: {
                                                                    position: 'bottom' as const,
                                                                    display: true,
                                                                    labels: rvLegendLabels,
                                                                },
                                                                title: {
                                                                    display: false,
                                                                    text: 'Chart.js Horizontal Bar Chart',
                                                                },
                                                                zoom: {
                                                                    pan: {
                                                                        enabled: false,
                                                                        onPan: this.onPan,
                                                                    },
                                                                    zoom: {
                                                                        wheel: {
                                                                            enabled: false,
                                                                        },
                                                                    },
                                                                    // limits: {
                                                                    //   y: { min: 0, max: 9 },
                                                                    // },
                                                                },
                                                                tooltip: {
                                                                    ...rvTooltipStyle,
                                                                    callbacks: {
                                                                        // tslint:disable-next-line: no-any
                                                                        label: function (context: any) {
                                                                            const {
                                                                                dataIndex,
                                                                                // label,
                                                                                formattedValue,
                                                                                dataset,
                                                                            } = context;
                                                                            var currentEstimate = estimates[dataIndex];

                                                                            var estimateString = '';

                                                                            if (currentEstimate) {
                                                                                estimateString = `Estimated Fees ${symbol}${formatNumber(currentEstimate)}`;
                                                                            }

                                                                            if (dataset.label.toLowerCase() === 'leads') {
                                                                                return `Leads ${formattedValue} ${estimateString}`;
                                                                            } else {
                                                                                return `Average Leads ${formattedValue} ${estimateString}`;
                                                                            }
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {isChartDataEmpty(lastThreeYearsNewMatterCount, newMatterCount) && (
                                                        <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                                                    )}
                                                </BarContainer>
                                                <FooterDescription>
                                                    {symbol}
                                                    {formatNumber(lastTwelveMonths.totalEstimates)} total estimated fees,
                                                    <br />
                                                    {formatNumber(lastTwelveMonths.mattersWithoutEstimate)} leads without estimates in the last 12 months
                                                    <br />
                                                    {symbol}
                                                    {formatNumber(previousTwelveMonths.totalEstimates)} total estimated fees, <br />
                                                    {formatNumber(previousTwelveMonths.mattersWithoutEstimate)} leads without estimates in the 12 months before that
                                                </FooterDescription>
                                            </BarWrapper>
                                        );
                                    }

                                    return (
                                        <LoadWrapper className="load-wrapper">
                                            <RvLoader size="small" />
                                        </LoadWrapper>
                                    );
                                }}
                            </Query>
                        );
                    }}
                </Query>
            </React.Fragment>
        );
    }

    private handleTotalClick(isCurrent: boolean) {
        if (this.props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();
            searchCriterias.push(
                { property: '12MonthPeriod', operator: 'eq', comparison: isCurrent ? 'curr' : 'prev' },
                { property: 'isLead', operator: 'eq', comparison: 'true' },
            );

            this.props.getSelectedItem(
                searchCriterias, 
                false, 
                'New Leads This Year', 
                DrillDownType.matterSummaryDrilldown, 
                'Matters',
                undefined,
                undefined,
                undefined,
                undefined,
                true
            );
        }
    }

    private onCloseChart() {
        if (this.props.onCloseChart) {
            return this.props.onCloseChart('isNewLeadsVsThreeYearsAverageChartOpen');
        }
    }

    // tslint:disable-next-line: no-any
    private handlePopoverOpen(event: any) {
        this.setAnchorEl(event.currentTarget);
    }

    private handlePopoverClose = () => {
        this.setAnchorEl(null);
    }

    // tslint:disable-next-line: no-any
    private setAnchorEl(anchorElValue: any) {
        this.setState({
            anchorEl: anchorElValue,
            open: Boolean(anchorElValue),
        });
    }
    private onPan = (context: { chart: Chart }) => {
        this.chartRef.current.options.scales.y.min = 0;
        this.chartRef.current.update();
    }

    private onHover(event: ChartEvent, elements: ActiveElement[], chart: Chart) {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    }
    
    private onToggleVideo() {
        this.setState({
            isVideoModalOpen: !this.state.isVideoModalOpen
        });
    }
}

// tslint:disable-next-line: no-any
export default withStyles(styles as any, { withTheme: true })(NewLeadsVsThreeYearsAverageChart as any) as any;

const CurrencySymbol = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

interface NewMatterLeadVsAverageByMonthDataVariables {
    entityType?: number;
    entityGuid?: string;
    responsibility?: number;
    filter?: string;
}

interface NewMatterLeadVsAverageByMonthDataData {
    statistics: Statistics;
}

interface Statistics {
    matter: Matter;
}

interface Matter {
    newMatterLeadVsAverageByMonth: NewMatterLeadVsAverageByMonth;
}

interface NewMatterLeadVsAverageByMonth {
    matterLeadsOpenedCountTotal:             MatterLeadsOpenedCountTotal;
    previousYearMatterLeadsOpenedCountTotal: MatterLeadsOpenedCountTotal;
    lastThreeYearsNewMatterLeadCount:        NewMatterLeadCount[];
    newMatterLeadCount:                      NewMatterLeadCount[];
}

interface NewMatterLeadCount {
    count:    number;
    month:    string;
    year:     null | string;
    estimate: number;
}

interface MatterLeadsOpenedCountTotal {
    count:                  number;
    mattersWithoutEstimate: number;
    totalEstimates:         number;
}

const NewMatterLeadVsAverageByMonthDataQuery = gql`
    query NewMatterLeadVsAverageByMonthData($entityType: Int, $entityGuid: String, $responsibility: Int, $filter: String) {
        statistics {
            matter {
                newMatterLeadVsAverageByMonth(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility, filter: $filter) {
                    matterLeadsOpenedCountTotal {
                        count
                        mattersWithoutEstimate
                        totalEstimates
                    }
                    previousYearMatterLeadsOpenedCountTotal {
                        count
                        mattersWithoutEstimate
                        totalEstimates
                    }
                    lastThreeYearsNewMatterLeadCount {
                        count
                        month
                        year
                        estimate
                    }
                    newMatterLeadCount {
                        count
                        month
                        year
                        estimate
                    }
                }
            }
        }
    }
`;
